import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const NAV_OFFSET = 96;

const scrollToHashTarget = (hash) => {
  const id = (hash || "").replace(/^#/, "");
  if (!id) return false;

  const el = document.getElementById(id);
  if (!el) return false;

  const top = el.getBoundingClientRect().top + window.pageYOffset - NAV_OFFSET;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: "smooth",
  });

  return true;
};

const HashAnchorScroll = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Ei hashia => ei tehdä mitään
    if (!hash) return;

    let rafId = 0;
    let tries = 0;
    const maxTries = 60; // ~1s @60fps, riittää hyvin renderöinnille

    const tick = () => {
      const ok = scrollToHashTarget(hash);
      if (ok) return;

      tries += 1;
      if (tries < maxTries) {
        rafId = window.requestAnimationFrame(tick);
      }
    };

    // Anna routen/renderin tapahtua ensin
    rafId = window.requestAnimationFrame(tick);

    return () => {
      if (rafId) window.cancelAnimationFrame(rafId);
    };
  }, [pathname, hash]);

  return null;
};

export default HashAnchorScroll;
